import { combineReducers } from "redux";
import BOCDeviceConnectionServiceSlice from "./CSAgentPortal/BOC/BOCDeviceConnectionServiceSlice";
import DisconnectBOCOnlineFunctionsServiceSlice from "./CSAgentPortal/BOC/DisconnectBOCOnlineFunctionsServiceSlice";

export default combineReducers({
    BOCDeviceConnectionService:BOCDeviceConnectionServiceSlice,
    DisconnectBOCOnlineFunctionsService:DisconnectBOCOnlineFunctionsServiceSlice
})